import axios, { AxiosError, AxiosResponse } from "axios";

import { DAO_SESHAT } from "@/api/DAO";
import { CMS_URL, CMS_URL_URL } from "@/api/URL-constants";

import {
  Cms,
  CmsResponse,
  CmsUrl,
  CmsUrlResponse
} from "@/models/api/cms.model";

const getCms = () => {
  return DAO_SESHAT()
    .get(`${CMS_URL}`)
    .then((response: AxiosResponse<CmsResponse>): Cms[] => {
      return response.data.data;
    });
};

const getCmsUrl = (cmsId: number) => {
  return DAO_SESHAT()
    .get(`${CMS_URL_URL}/${cmsId}`)
    .then((response: AxiosResponse<CmsUrlResponse>): CmsUrl => {
      return response.data.data;
    })
    .catch((error: Error | AxiosError) => {
      if (axios.isAxiosError(error) && error.response) {
        throw error.response.data.message;
      } else {
        throw error.message;
      }
    });
};

export { getCms, getCmsUrl };
